import { Injectable } from '@angular/core'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { take } from 'rxjs/operators'
import { FeesOverlayComponent } from './fees-overlay.component'

@Injectable()
export class FeesOverlayService {
  constructor(private dialog: MatDialog) {}

  public open(): MatDialogRef<FeesOverlayComponent> {
    const config = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      panelClass: ['modal', 'side-modal-lg', 'overlay-20', 'right'],
    }

    const dialogRef = this.dialog.open(FeesOverlayComponent, config)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }
}
